import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetProjectsByAPIKeyRPC } from "./getProjectsByApiKeyRPC";

export class GetProjectsByAPIKeyRPCClientImpl extends GetProjectsByAPIKeyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetProjectsByAPIKeyRPC.Request): Promise<LeoRPCResult<GetProjectsByAPIKeyRPC.Response, GetProjectsByAPIKeyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "external-public-apis/GetProjectsByAPIKey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetProjectsByAPIKeyRPC.ResponseDTO,
      GetProjectsByAPIKeyRPC.Errors.ErrorsDTO,
      GetProjectsByAPIKeyRPC.Response,
      GetProjectsByAPIKeyRPC.Errors.Errors
    >(
      response,
      "external-public-apis/GetProjectsByAPIKey",
      GetProjectsByAPIKeyRPC.Response.fromDTO,
      GetProjectsByAPIKeyRPC.Errors.fromDTO
    );
  }
}
